// TanStack Query keys for the Team Chat caches. Kept out of the provider
// module so that file exports only components/hooks (react-refresh) and so
// cache patches made outside the provider (optimistic reactions, tests) share
// one vocabulary with the hub handlers.
export const TEAM_CONTEXT_KEY = ['team-context'];
/** Prefix matching every cached conversation page — for reconnect reconciles. */
export const TEAM_MESSAGES_KEY_PREFIX = ['team-messages'];
export const teamMessagesKey = (conversationId) => ['team-messages', conversationId];
/** Prefix matching every cached thread — for setQueriesData fan-out and
 * reconnect reconciles. */
export const TEAM_THREAD_KEY_PREFIX = ['team-thread'];
export const teamThreadKey = (messageId) => ['team-thread', messageId];
